var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdyenVectorLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "layer",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 652 217.6"
    },
    viewBox: "0 0 652 217.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#0abf53}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.2 54H16.8v27.5h56.3c3.5 0 6.3 2.8 6.3 6.3v48.7h-12c-3.5 0-6.3-2.8-6.3-6.3v-35H37.3c-12.2 0-22.1 9.9-22.1 22.1v24.6c0 12.2 9.9 22.1 22.1 22.1h88V76c-.1-12.1-9.9-22-22.1-22M207.8 136.5h-12c-3.5 0-6.3-2.8-6.3-6.3V54h-23.8c-12.2 0-22.1 9.9-22.1 22.1V142c0 12.2 9.9 22.1 22.1 22.1h88V8.1h-45.9v128.4zM336.2 136.5h-12c-3.5 0-6.3-2.8-6.3-6.3V54H272v88c0 12.2 9.9 22.1 22.1 22.1h42.1v13.8h-62.6V210H360c12.2 0 22.1-9.9 22.1-22.1V54h-45.9v82.5zM488.3 54h-88v88c0 12.2 9.9 22.1 22.1 22.1h86.4v-27.5h-56.3c-3.5 0-6.3-2.8-6.3-6.3V81.6h12c3.5 0 6.3 2.8 6.3 6.3v35h23.8c12.2 0 22.1-9.9 22.1-22.1V76.2c0-12.3-9.9-22.2-22.1-22.2M616.7 54h-88v110.1h45.9V81.6h12c3.5 0 6.3 2.8 6.3 6.3v76.2h45.9v-88c0-12.2-9.9-22.1-22.1-22.1",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdyenVectorLogo);
export default __webpack_public_path__ + "static/media/adyen-vector-logo.f24caa4b468a0e7943d243b6fa56bc6f.svg";
export { ForwardRef as ReactComponent };